import { Expose } from "class-transformer";

export class CreateSubtaskDto {
  @Expose()
  name: string;

  @Expose()
  taskTypeId: string;
}
